// Dependency-free Russian relative time for the feed («5 мин назад», «вчера»).
// Beyond a week the exact date reads better than «N недель назад».

const MINUTE = 60_000;
const HOUR = 3_600_000;
const DAY = 86_400_000;

function plural(n: number, one: string, few: string, many: string): string {
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod10 === 1 && mod100 !== 11) return one;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return few;
  return many;
}

export function relativeTime(iso: string | null, now: number = Date.now()): string {
  if (!iso) return '';
  const then = Date.parse(iso);
  if (Number.isNaN(then)) return '';
  const diff = now - then;
  if (diff < MINUTE) return 'только что';
  if (diff < HOUR) {
    const m = Math.floor(diff / MINUTE);
    return `${m} ${plural(m, 'минуту', 'минуты', 'минут')} назад`;
  }

  if (diff < DAY) {
    const h = Math.floor(diff / HOUR);
    return `${h} ${plural(h, 'час', 'часа', 'часов')} назад`;
  }

  if (diff < 2 * DAY) return 'вчера';
  if (diff < 7 * DAY) {
    const d = Math.floor(diff / DAY);
    return `${d} ${plural(d, 'день', 'дня', 'дней')} назад`;
  }

  return new Date(then).toLocaleDateString('ru-RU', { day: 'numeric', month: 'long' });
}
